import {put, call, takeEvery} from 'redux-saga/effects';
import  * as constants from "./actions";
import * as Actions from "./constants";
import {toast} from "react-toastify";
import AdminsService from "../../api/services/admins.service";
const _adminsService = new AdminsService();

/**
 * @param loginPayload
 */
function* listPaysSaga(loginPayload) {
     const url ='pays'
    try {
        const response = yield call(_adminsService.geList,url);
        yield put(constants.paysListSuccess(response?.data?.pays));
    } catch (error) {
        const { message } = error.data
    console.log("new error" , message);
        yield put(constants.paysListFailed(error));
        yield call(toast.error(message))
    }
}

export default function* paysSaga() {
    yield takeEvery(Actions.PAYS_LIST_REQUESTING, listPaysSaga);
}
